import {Label} from "../../../basic/label";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "../../../basic/select";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {useGetAdminProductsQuery} from "../../../../store/generated/api";
import {Skeleton} from "../../../basic/skeleton";

interface ProductSelectorProps {
    value: string;
    onChange: (value: string) => void;
}

export function ProductSelector({value, onChange}: ProductSelectorProps) {
    const {t} = useTranslationWithKeys();
    const {data: productsData, isLoading, error} = useGetAdminProductsQuery({
        page: 0,
        size: 100 // Get all products for selection
    });

    if (isLoading) {
        return (
            <div className="space-y-2">
                <Label htmlFor="product">{t('admin.licenses.createLicenseDialog.product')} *</Label>
                <Skeleton className="h-10 w-full"/>
            </div>
        );
    }

    if (error) {
        return (
            <div className="space-y-2">
                <Label htmlFor="product">{t('admin.licenses.createLicenseDialog.product')} *</Label>
                <Select disabled>
                    <SelectTrigger id="product">
                        <SelectValue placeholder={t('common.error.loadingFailed')}/>
                    </SelectTrigger>
                </Select>
            </div>
        );
    }

    return (
        <div className="space-y-2">
            <Label htmlFor="product">{t('admin.licenses.createLicenseDialog.product')} *</Label>
            <Select
                value={value}
                onValueChange={onChange}
            >
                <SelectTrigger id="product">
                    <SelectValue placeholder={t('admin.licenses.createLicenseDialog.selectProduct')}/>
                </SelectTrigger>
                <SelectContent>
                    {productsData?.products?.map((product) => (
                        <SelectItem key={product.id} value={product.id}>
                            {product.name}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}